// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__1OhnT","list":"PatternAutocomplete_list__2-OWW"};